import { discrepancies } from "./discrepancies";
import { reconciliation_status } from "./reconciliation_status";
import { aging } from "./aging";
import { discounts_credits } from "./discounts_credits";
import { supplier_scorecards } from "./supplier_scorecards";
import { throughput } from "./throughput";

// The report= seam: every future family registers here.
export const reports = { discrepancies, reconciliation_status, aging, discounts_credits, supplier_scorecards, throughput };
export const reportList = Object.values(reports);
